import $ from "jquery";

/**
 * Provides ability to register view
 */
export default class ViewRegistry {
    constructor() {
        this.views = new Map();
    }

    /**
     * Adds view to registry
     * @param view Backbone view instance
     * @param name name of view
     * @param selectors css-selectors of DOM-elements for automatic initialization. Default is [data-initview=${name}]
     */
    addView(view, name, selectors) {
        if (!selectors) {
            selectors = [];
        }
        selectors.push(`[data-initview=${name}]`);
        this.views.set(name, {
            "selectors": selectors,
            "view": view,
            "instances": []
        })
    }

    /**
     * Provides access to registered vew
     * @param name
     */
    getView(name) {
        this.views.get(name);
    }

    /**
     * Automatically initialize views with selected views
     */
    initViews() {
        for (var [name, view] of this.views) {
            for (let selector of view.selectors) {
                $(selector).each(function (index, element) {
                    let $el = $(element),
                        data = $el.data();
                    if (!data.used && !data.blockinit) {
                        data['el'] = element;
                        console.log(view);
                        view.instances.push(new view.view(data));
                        $el.data("used", true);
                    }
                }.bind(this))
            }
        }
    }
}



// WEBPACK FOOTER //
// ./frontend/js/utils/register.js